import { ServiceStoreConfig } from "./types/ServiceStoreTypes";

// Import categorized service stores

import { administrationStores } from "./serviceStores/administration.stores";
import { systemStores } from "./serviceStores/system.stores";
import { userStores } from "./serviceStores/user.stores";
import { aiStores } from "./serviceStores/ai.stores";
import { aiAgentStores } from "./serviceStores/aiAgent.stores";
import { clientsStores } from "./serviceStores/clients.stores";
import { whiteboardRollupStores, whiteboardStores } from "./serviceStores/whiteboard.stores";
import { ticketsStores } from "./serviceStores/tickets.stores";
import { modulesStores } from "./serviceStores/modules.stores";
import { devopsStores } from "./serviceStores/devops.stores";
import { infrastructureStores } from "./serviceStores/infrastructure.stores";
import { meetingIntelligenceStores } from "./serviceStores/meetingIntelligence.stores";
import { homeStores } from "./serviceStores/home.stores";
import { dashboardStores } from "./serviceStores/dashboard.stores";
import { adminStores } from "./serviceStores/admin.stores";
import { billingStores } from "./serviceStores/billing.stores";
import { dataMapperStores } from "./serviceStores/dataMapper.stores";
import { reportsStores } from "./serviceStores/reports.stores";
import { reportsToolStores } from "./serviceStores/reportsTool.stores";

/**
 * Main Service Store Configuration
 * Combines all categorized service stores into a single array
 *
 * Categories mirror the per-domain files under src/serviceStores/:
 * - Administration: departments and related admin entities (administration.stores.ts)
 * - System: api-services, notifications, etc. (system.stores.ts)
 * - User: users, roles, permissions, etc. (user.stores.ts)
 *
 * This array is also what `generateServiceViewRoutes()` reads: any entry with
 * `options.serviceView.enableServiceView` gets an auto-generated raw grid at
 * /management/data/<service-path>, auth + ADMIN gated, in the "Management" nav
 * group. That set is deliberately small and reference-data only —
 * `module-catalog`, `module-governance`, `module-releases`, `departments` — and
 * the asserted roster lives in views/utils/ServiceViewRouteGenerator.test.ts.
 * Before adding one, check the generated route name (`"<Title> Management"`)
 * and path against routesList: route lookup in rootStoreConfig is keyed by
 * name, so a duplicate name silently REPLACES the hand-built route.
 */
const serviceStores: ServiceStoreConfig[] = [
  ...administrationStores,
  ...systemStores,
  ...userStores,
  ...billingStores,
  ...aiStores,
  ...aiAgentStores,
  ...clientsStores,
  ...whiteboardStores,
  ...whiteboardRollupStores,
  ...ticketsStores,
  ...modulesStores,
  ...devopsStores,
  ...infrastructureStores,
  ...meetingIntelligenceStores,
  ...homeStores,
  // The Developer Dashboard's four board/instance/share/prefs stores, taken
  // from @intrasync/dashboard so the paths cannot drift from the api mount.
  ...dashboardStores,
  ...adminStores,
  ...dataMapperStores,
  ...reportsStores,
  // The reports tool's eight `reports-*` stores, taken from @intrasync/reports
  // so the paths cannot drift from the api mount. NOT `reportsStores` above,
  // which is Developer Metrics.
  ...reportsToolStores,
];

export default serviceStores;
